import { useEffect, useState } from "react";
import { Container, Table } from "../../../components";
import { dataTable, getBarrio, getJefes } from "./handlers";
import { useParams } from "react-router-dom";
import ActualizarBarrio from "./form/update-barrio";
import CrearJefeComuna from "./form/create-jefe-comuna";
import ActivarJefe from "./form/activar-jefe-comuna";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/UserWrapper";
import { useContext } from "react";

export default function Barrio() {
  const { id } = useParams();
  const { actions: ua } = useContext(UserContext);
  const nav = useNavigate();

  const [rta, setRta] = useState({
    data: null,
    error: null,
    loading: false,
  });

  const [open, setOpen] = useState(false);

  const [abrir, setAbrir] = useState(false);

  const [jefeId, setJefeId] = useState(null);

  useEffect(() => {
    if (ua.hasRole("admin.app")) {
      getBarrio(rta, setRta, id);
    } else {
      nav("/");
    }
  }, []);

  useEffect(() => {
    if (rta.data && rta.error == null) {
      setJefes({ data: rta.data.jefes, error: null, loading: false });
    }
  }, [rta]);

  const [jefes, setJefes] = useState({
    data: [],
    error: null,
    loading: false,
  });

  const actualizarJefes = async () => {
    getJefes(jefes, setJefes, id);
  };

  return (
    <Container linkBack={"/barrios"} titulo={"Información del Barrio"}>
      {rta.loading && (
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )}
      {rta.data && <ActualizarBarrio barrio={rta.data} />}
      {rta.data && (
        <div>
          <Table
            data={dataTable(jefes.data, abrir, setAbrir, setJefeId)}
            loading={jefes.loading}
            search={true}
            render={() => {
              return (
                <div className="mt-2 mb-2 mx-2 d-flex align-items-center">
                  <button
                    className="btn btn-sm btn-primary"
                    type="button"
                    onClick={() => setOpen(true)}
                  >
                    Crear Jefe de Comuna
                  </button>
                </div>
              );
            }}
          />
          <ActivarJefe
            abrir={abrir}
            setAbrir={setAbrir}
            barrio_id={id}
            jefeId={jefeId}
            actualizarJefes={actualizarJefes}
          />
          <CrearJefeComuna
            open={open}
            setOpen={setOpen}
            actualizarJefes={actualizarJefes}
            id={id}
          />
        </div>
      )}
    </Container>
  );
}
